import React from 'react';
import YogaDay2025  from 'views/YogaDay2025';

const InternationalYogaDayPage = () => {
    return <YogaDay2025 />;
  };
  
  export default InternationalYogaDayPage; 